import ButtonWithArrowIcon from '../ButtonWithArrowIcon';
import * as React from 'react';

type InputProps = {
  children: string;
  email: string;
  subject: string;
  body: string;
};

export const EmailButtonWithParams = ({
  children,
  email,
  subject,
  body,
}: InputProps) => {
  return (
    <a
      href={`mailto:${email}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ButtonWithArrowIcon>{children}</ButtonWithArrowIcon>
    </a>
  );
};
